<template>
  <v-card
    :flat="isFlat"
    class="py-3 mt-3"
  >
    <form-group title="Dados do Serasa">
      <v-row justify="start">
        <v-col cols="6">
          <client-personal-data-view
            v-model="payload.dataByBigData"
            :loading="isLoading"
            :compare="compareUserData"
            :omits="['fathersName']"
            autofill="Não retornado"
          />
        </v-col>
      </v-row>
    </form-group>
    <form-group>
      <v-row>
        <v-col cols="12">
          <v-divider />
        </v-col>
      </v-row>
    </form-group>
    <form-group title="Dados da empresa pelo Serasa">
      <v-row justify="start">
        <v-col cols="6">
          <company-data-view
            v-model="payload.companyDataByBigData"
            :loading="isLoading"
            autofill="Não retornado"
            class="mb-3"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <span class="h2Header secondary300">Endereços:</span>
          <address-table
            v-model="payload.businessAddressesByBigData"
            :loading="isLoading"
            class="mt-3"
          />
        </v-col>
      </v-row>
    </form-group>
  </v-card>
</template>

<script>
import AnalysisCardMixin from 'Modules/contacard/analysisTable/components/cards/AnalysisCardMixin';
import ClientPersonalDataView from 'Modules/contacard/analysisTable/components/dataViews/ClientPersonalDataView.vue';
import CompanyDataView from 'Modules/contacard/analysisTable/components/dataViews/CompanyDataView.vue';
import AddressTable from 'Modules/contacard/analysisTable/components/tables/AddressTable.vue';

export default {
  name: 'ClientCompanyBigDataInfoCard',
  components: {
    ClientPersonalDataView,
    CompanyDataView,
    AddressTable,
  },
  mixins: [AnalysisCardMixin],
};
</script>
